import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Navigation from './Navigation';
import config from '../config';

const CompleteSignup = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const params = new URLSearchParams(location.search);
  const email = params.get('email');
  const sessionId = params.get('session_id');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email) {
      setError('Email is required');
      return;
    }

    if (!password || password.length < 8) {
      setError('Password must be at least 8 characters long');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${config.apiUrl}/api/complete-signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          password,
          sessionId
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to complete signup');
      }

      // Store token and login
      localStorage.setItem('token', data.token);
      login(data.token);

      // Redirect to dashboard
      navigate('/dashboard');
    } catch (err) {
      console.error('Complete signup error:', err);
      setError(err.message || 'Failed to complete signup');
    } finally {
      setLoading(false);
    }
  };

  if (!email) {
    return (
      <div className="page-container">
        <Navigation />
        <main className="main-content">
          <div className="container">
            <h1 className="page-title heading-2">Invalid Request</h1>
            <p>Missing required information. Please try again from the pricing page.</p>
            <button 
              className="button button-primary"
              onClick={() => navigate('/pricing')}
            >
              Back to Pricing
            </button>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="page-container">
      <Navigation />
      <main className="main-content">
        <div className="container">
          <h1 className="page-title heading-2">Complete Your Signup</h1>
          <p>Almost there! Just set your password to complete your account setup.</p>
          
          <form onSubmit={handleSubmit} className="form">
            <div className="form-group">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                type="email"
                id="email"
                className="form-input"
                value={email}
                disabled
              />
            </div>

            <div className="form-group">
              <label htmlFor="password" className="form-label">Password</label>
              <input
                type="password"
                id="password"
                className="form-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Choose a strong password"
                required
                minLength={8}
              />
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
              <input
                type="password"
                id="confirmPassword"
                className="form-input"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm your password"
                required
                minLength={8}
              />
            </div>

            {error && (
              <div className="error-message">
                <p>{error}</p>
              </div>
            )}

            <button 
              type="submit" 
              className="button button-primary"
              disabled={loading}
            >
              {loading ? 'Setting Up Account...' : 'Complete Signup'}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default CompleteSignup;
